export default "__VITE_ASSET__948ca4c4__"